/**
 * @author Jersson Stiven Morales Alza
 * @Copyright (c) Infotrack. All rights reserved.
 */
import { TipoFormulario } from '@infotrack/presentacion-transversales/interfacesComunes';
import ITiposClientes from 'Infotrack@Modelos/smartStock/tiposClientes/entidades/tiposClientes';
import { AnyAction } from 'redux';

export interface IEstadoTiposClientes {
    estadoFormulario: boolean;
    entidadTiposClientes: ITiposClientes | null;
    recargarTabla: boolean;
    tipoFormulario: TipoFormulario;
}

export const estadoIncial: IEstadoTiposClientes = {
    entidadTiposClientes: null,
    estadoFormulario: false,
    recargarTabla: false,
    tipoFormulario: TipoFormulario.Creacion,
};

export enum acciones {
    CAMBIAR_ESTADO_FORMULARIO = 'CAMBIAR_ESTADO_FORMULARIO',
    RECARGAR_TABLA = 'RECARGAR_TABLA',
}

export const reductor = (estado: IEstadoTiposClientes, { type, payload }: AnyAction) => {
    switch (type) {
        case 'CAMBIAR_ESTADO_FORMULARIO': {
            return {
                ...estado,
                entidadTiposClientes: payload ? payload.entidadTiposClientes : null,
                estadoFormulario: !estado.estadoFormulario,
                tipoFormulario: payload ? payload.tipoFormulario : estado.tipoFormulario,
            };
        }
        case 'RECARGAR_TABLA':
            return {
                ...estado,
                recargarTabla: !estado.recargarTabla,
            };

        default:
            return estado;
    }
};
